import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
 name: 'orderBy'
})
export class orderBy implements PipeTransform{

 transform(array: any[], args: string): Array<string> {
    if(!array || array === undefined || array.length === 0) return null;
    
    if(args == null) return array;

    return array.filter( cleaner => {
      var firstChar = cleaner.cleaner_name.charAt(0).toUpperCase();
      if(firstChar == args) return true;
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/pipes/orderBy.pipe.ts